import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  EmbedScriptOptions,
  EmbedScriptResponse,
  GetEmbeddedScriptOptions,
  ScriptProperties,
  embedScript as universalEmbedScript,
  getEmbeddedScript as universalGetEmbeddedScript,
} from './devcenter-scripts-v1-script-properties-embedded-scripts.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/app-management' };

export function embedScript(httpClient: HttpClient): EmbedScriptSignature {
  return (properties: ScriptProperties, options?: EmbedScriptOptions) =>
    universalEmbedScript(
      properties,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface EmbedScriptSignature {
  /**
   * Inserts custom script tags into a site, with the specified values for any dynamic parameters. Call this method when your app is installed on a site.
   *
   * Your app must have an existing
   * [embedded script component](https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/embedded-scripts/about-embedded-scripts),
   * with exactly matching parameter names.
   * @param - Details of the script to embed.
   */
  (properties: ScriptProperties, options?: EmbedScriptOptions): Promise<
    NonNullablePaths<EmbedScriptResponse, `properties.disabled`, 3>
  >;
}

export function getEmbeddedScript(
  httpClient: HttpClient
): GetEmbeddedScriptSignature {
  return (options?: GetEmbeddedScriptOptions) =>
    universalGetEmbeddedScript(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetEmbeddedScriptSignature {
  /**
   * Retrieves information about your app's existing embedded script.
   *
   * If your app doesn't have an embedded script on the relevant site, a `404` error is returned.
   * @returns Details of the retrieved embedded script.
   */
  (options?: GetEmbeddedScriptOptions): Promise<
    NonNullablePaths<ScriptProperties, `disabled`, 2>
  >;
}

export {
  EmbedScriptByInstanceIdRequest,
  EmbedScriptOptions,
  EmbedScriptRequest,
  EmbedScriptResponse,
  GetEmbeddedScriptByInstanceIdRequest,
  GetEmbeddedScriptOptions,
  GetEmbeddedScriptRequest,
  GetEmbeddedScriptResponse,
  ScriptProperties,
} from './devcenter-scripts-v1-script-properties-embedded-scripts.universal.js';
